export default __webpack_public_path__ + "static/dog-illustration-ba794f5323e5885d26da5b9f7aa077a1.svg";